import React from 'react';
import { useFilters } from '../FilterContext';
import EMIChip from 'components/Elements/EMIChip/EMIChip';

export const ChipsFilter = () => {
	const { config, updateFilter, filterValues } = useFilters();
	const chipsConfig = config.filters?.chips;

	// Get chips from FilterContext (initialization handled by useFilterInitialization in parent component)
	const chips = filterValues.chips?.value || [];
	
	if (!chipsConfig?.enabled) {
		return null;
	}
	const hiddenChipTypes = chipsConfig.hiddenTypes || [];
	
	// Filter chips based on configuration - only show non-hidden chips
	const visibleChips = chips.filter(chip => 
		!hiddenChipTypes.includes(chip.chipType)
	);

	const handleRemoveChip = (chipToRemove) => {
		const updatedChips = chips.filter(chip => 
			!(chip.chipType === chipToRemove.chipType && 
			  chip.id === chipToRemove.id && 
			  chip.value === chipToRemove.value)
		);
		updateFilter('chips', updatedChips, { chips: updatedChips });
	};

	// Always render container with spacing, only show chips if there are visible ones
	return (
		<div style={{ marginTop: 20 }}>
			{visibleChips.length > 0 && (
				<EMIChip
					data={visibleChips}
					deleteHandler={handleRemoveChip}
					hideChips={hiddenChipTypes}
				/>
			)}
		</div>
	);
};